#import "./StaffQuizAttemptFields.graphql"

mutation StartTrainingQuizAttempt($moduleId: ID!) {
  startTrainingQuizAttempt(input: { moduleId: $moduleId }) {
    attempt {
      ...StaffQuizAttemptFields
    }
  }
}
